import React from "react";
import styled from "styled-components";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { useProjectContext } from "../../context/useProjectContext";
import { ShieldCheck } from "lucide-react";

const MemberAccessBanner = ({ seatBased = false }) => {
    const { isAdmin } = useProjectContext();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    if (!isAdmin) return null;

    const handleManageAccess = () => {
        navigate({
        pathname: "/project",
        search: createSearchParams(searchParams).toString(),
        });
    };

    return (
        <Banner>
            <ShieldCheck size={16} color="#6b7280" style={{ flexShrink: 0, marginTop: 2 }} />
            <BannerText>
                {seatBased
                    ? "Other users can add seats and manage this subscription. Click "
                    : "You can grant other users access to this product. Click "}
                <ManageLink onClick={handleManageAccess}>Manage access</ManageLink>
                {seatBased
                    ? " to provide them with this permissions."
                    : " to add members and assign permissions."}
            </BannerText>
        </Banner>
    );
};

export default MemberAccessBanner;

const Banner = styled.div`
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
`;

const BannerText = styled.p`
    color: #344054;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
`;

const ManageLink = styled.span`
    font-weight: 600;
    color: #6941c6;
    cursor: pointer;
    text-decoration: underline;
    &:hover { color: #53389e; }
`;